import React from 'react';
import { Clock } from 'lucide-react';
import { DaySchedule, GLOBAL_PHONE } from '../../data/locations';
interface LocationScheduleProps {
  schedule?: DaySchedule[];
  hasSchedule: boolean;
  locationName: string;
}
export function LocationSchedule({
  schedule,
  hasSchedule,
  locationName
}: LocationScheduleProps) {
  if (!hasSchedule) {
    return <section className="py-16 bg-slate-50" data-id="element-518">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-519">
          <div className="text-center mb-8" data-id="element-520">
            <div className="inline-flex items-center justify-center p-3 bg-white rounded-full mb-4" data-id="element-521">
              <Clock className="h-6 w-6 text-[#dc2626]" data-id="element-522" />
            </div>
            <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-523">
              Class Schedule
            </h2>
          </div>

          <div className="max-w-2xl mx-auto bg-white rounded-xl border border-slate-200 shadow-sm p-8 text-center" data-id="element-524">
            <h3 className="text-xl font-bold text-[#1a2332] mb-4" data-id="element-525">
              Schedule Coming Soon
            </h3>
            <p className="text-slate-600 mb-6" data-id="element-526">
              We're currently finalizing the class schedule for {locationName}.
            </p>
            <p className="text-slate-700 font-medium" data-id="element-527">
              Call or text{' '}
              <a href={`tel:${GLOBAL_PHONE.replace(/\D/g, '')}`} className="text-[#dc2626] hover:text-[#b91c1c] transition-colors" data-id="element-528">
                {GLOBAL_PHONE}
              </a>{' '}
              for current class times.
            </p>
          </div>
        </div>
      </section>;
  }
  return <section className="py-16 bg-slate-50" data-id="element-529">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-530">
        <div className="text-center mb-12" data-id="element-531">
          <div className="inline-flex items-center justify-center p-3 bg-white rounded-full mb-4" data-id="element-532">
            <Clock className="h-6 w-6 text-[#dc2626]" data-id="element-533" />
          </div>
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-534">
            Class Schedule
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-535">
            All classes are included in your membership. Drop in to any class
            that fits your schedule.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-536">
          {schedule?.map((day, index) => <div key={index} className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-537">
              <h3 className="text-lg font-bold text-[#1a2332] mb-4 pb-3 border-b border-slate-200" data-id="element-538">
                {day.day}
              </h3>
              <div className="space-y-3" data-id="element-539">
                {day.classes.map((classItem, classIndex) => <div key={classIndex} className="text-sm" data-id="element-540">
                    <div className="font-medium text-[#dc2626] mb-1" data-id="element-541">
                      {classItem.time}
                    </div>
                    <div className="text-slate-700" data-id="element-542">{classItem.name}</div>
                  </div>)}
              </div>
            </div>)}
        </div>

        <div className="mt-8 text-center" data-id="element-543">
          <p className="text-sm text-slate-600" data-id="element-544">
            Questions about the schedule?{' '}
            <a href={`tel:${GLOBAL_PHONE.replace(/\D/g, '')}`} className="text-[#dc2626] hover:text-[#b91c1c] font-medium transition-colors" data-id="element-545">
              Call {GLOBAL_PHONE}
            </a>
          </p>
        </div>
      </div>
    </section>;
}